import { Injectable } from '@angular/core';
import { FormbirdInjectorService } from '../injector/formbird-injector.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineUtilService {
  ajsService: any;

  constructor(private formbirdInjectorService: FormbirdInjectorService) {

    this.ajsService = formbirdInjectorService.get('OfflineUtilService');
  }

  getNextId() {
    return this.ajsService.getNextId();
  }
}
